import React, { useEffect, useMemo, useState } from "react";
import { HeadShowType } from "@/types/chat/enum";
import bus from "@/utils/bus";
import IconFont from "@/components/icon";
import { useTranslation } from "react-i18next";
import HeadPortrait from "@/baseComponents/Chat/HeadPortrait";
import { isGroupAdmin, isGroupOrdinary, isGroupOwner } from "@/utils/chat/group";
import { getUnitTitleInfo, isCardViewGroupSession, isEqualEmployee } from "@/utils/chat/message";
import { Drawer, Empty, Spin, message } from "antd";
import { connect } from "dva";
import ChatState from "@/types/chat/State";
import Context from "@/components/chat/context";
import { UserCardPayload } from "@/models";
import "./number.less";
import { getGroupInitMember } from "@/api/chat";
import ImService from "@/server/ImService";

function OriginMember(props: any) {
  const { selectedSession, currentEmployee, toggleUserCardModal } = props;
  const { groupRosterIdentity } = React.useContext(Context);
  const [member, setMember] = useState<any>([]);
  const groupId = selectedSession.sessionId;
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation("chat");
  const [visible, setVisible] = useState(false);
  const onClose = () => {
    setVisible(false);
    setMember([]);
  };
  async function getMember() {
    setLoading(true);
    const [data, error] = await getGroupInitMember({
      groupId: groupId
    });
    setLoading(false);
    const user = data.groupMembers.map((item: any) => {
      return {
        appId: item.app,
        teamId: item.teamId,
        userId: item.pin
      };
    });
    const memberInfo = await ImService.getInstance().getChangeUserDetailList(user, true);
    setMember(memberInfo);
  }
  useEffect(() => {
    bus.on("originNum:open", () => {
      setVisible(true);
      getMember();
    });
    return () => {
      bus.off("originNum:open");
    };
  }, []);
  const openUserCard = (data: any) => {
    const { userId, teamId, app } = data || {};
    const info: any = {
      userId,
      teamId,
      app
    };
    // 如果群成员并且禁止了查看群成员名片
    if (
      !isEqualEmployee(currentEmployee, info) &&
      isGroupOrdinary(groupRosterIdentity) &&
      !isCardViewGroupSession(selectedSession)
    ) {
      message.warn(t("can_not_open_user_card_tip"));
      return false;
    }

    toggleUserCardModal({ visible: true, userId, teamId, appId: app });
  };

  const desc = (unitName: string, titleName: string) => {
    const descinfo = getUnitTitleInfo(unitName, titleName);
    return descinfo;
  };
  const memberList = member.map((item: any, index: number) => {
    return (
      <div className="origin-member-list" key={index}>
        <HeadPortrait
          width="32px"
          height="32px"
          imgUrl={item.avatar}
          showType={HeadShowType.GROUP_MEMBER}
          name={item.name}
          isLeader={isGroupOwner(item.identity)}
          isAdmin={isGroupAdmin(item.identity)}
          onItemClick={() => {
            openUserCard(item);
          }}
          desc={desc(item.unitName, item.titleName)}
          showAlias={false}
          showExternalTag={true}
          member={item}
        />
      </div>
    );
  });
  const titleNode = useMemo(() => {
    return (
      <div>
        <IconFont
          type="iconwin_left"
          className="group-management-icon-arrow app-region-none"
          onClick={onClose}
        />
        <span className="management-title">{t("origin-group-member")}</span>
      </div>
    );
  }, [onClose, t]);
  return (
    <Drawer
      title={titleNode}
      className="origin-member-drawer"
      placement="right"
      width="375px"
      height="100%"
      mask={false}
      destroyOnClose={true}
      closable={false}
      onClose={onClose}
      visible={visible}
      style={{ position: "absolute", right: 0 }}
    >
      {loading && (
        <div className="loading">
          <Spin spinning={loading} />
        </div>
      )}
      {!loading && member.length > 0 && memberList}
    </Drawer>
  );
}

function mapStateToProps({ chat }: any) {
  const { selectedSession, currentEmployee } = chat as ChatState;
  return {
    selectedSession,
    currentEmployee
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    toggleUserCardModal(payload: UserCardPayload) {
      dispatch({ type: "app/toggleUserCardModal", payload });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OriginMember);
